$(function () {
    const validateEmail = (email) => {
        return email.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    };

    const siteUrl = window.location.origin;
    // desktop
    $(".newsletter-form").submit(function (e) {
        const $form = $(this);
        e.preventDefault();
        /* validate */
        const inputEmail = $("#input-email").val();
        if (!inputEmail) {
            showValidate("This field is required.");
            $form.find("#submit-button").css("display", "none");
            $form.find("#clear-input").css("display", "inline-block");

            return false;
        }
        if (!validateEmail(inputEmail)) {
            showValidate("Email format is not valid.");
            $form.find("#submit-button").css("display", "none");
            $form.find("#clear-input").css("display", "inline-block");

            return false;
        }
        /* remove all alert */
        hideAlert($form);
        /* remove field error*/
        clearFieldError($form);
        /* collect input data then disable inputs */
        const postData = $form.serialize();

        /* ajax post process */
        $.ajax({
            url: siteUrl + "/api/newsletter-content",
            type: "GET",
            data: {
                email: inputEmail,
            },
            success: function (data) {
                showValidate(
                    "Email already registered. Please use different email address."
                );
            },
            error: function (data) {
                $.ajax({
                    url: $form.attr("action"),
                    type: "POST",
                    data: postData,
                    success: function (data) {
                        /* disabled input on submit */
                        showSuccess($form);
                        $("#input-email").hide();
                        $("#submit-button").hide();
                    },
                    error: function (data) {
                        showError($form, data.responseJSON.error);
                    },
                });
            },
        });

        function clearFieldError($form) {
            $form.find("input, textarea, select").removeClass("is-invalid");
        }

        function hideAlert($form) {
            $form.find(".invalid-feedback").text("");
        }

        function showValidate(message) {
            $form.find(".invalid-feedback").text("");
            $form.find(".invalid-feedback").text(message);
            $form.find(".input-group").addClass("has-error");
            $form.find("#submit-button").css("display", "none");
            $form.find("#clear-input").css("display", "inline-block");
        }

        function showSuccess($form, message = "") {
            $form.find(".valid-icon").removeClass("d-none");
            $form
                .find(".valid-feedback")
                .text("You have been successfully subscribed.");
            $form.find(".input-group").addClass("has-success");
        }

        function showError($form, errors) {
            $form.find(".invalid-feedback").text("");
            $form.find(".input-group").addClass("has-error");
            $form.find("#submit-button").css("display", "none");
            $form.find("#clear-input").css("display", "inline-block");

            try {
                for (const [key, value] of Object.entries(errors)) {
                    $form.find(".invalid-feedback").append(`${value}<br/>`);
                    $form.find(`[name=${key}]`).addClass("is-invalid");
                    $form.find(`[name=${key}] + .invalid-feedback`).text(value);
                }
            } catch (e) {
                $form
                    .find(".invalid-feedback")
                    .text("Oops, something went wrong");
            }
        }
    });
    $("#clear-input").on("click", function () {
        $(".invalid-feedback").text("");
        $(".invalid-feedback").css("display", "none");
        $(".input-group").removeClass("has-error");
        $("#input-email").val("");
        $("#submit-button").css("display", "inline-block");
        $("#clear-input").css("display", "none");
    });
    // mobile
    $(".newsletter-form-mobile").submit(function (e) {
        const $form = $(this);
        e.preventDefault();
        /* validate */
        const inputEmail = $("#input-email-mobile").val();
        if (!inputEmail) {
            showValidate("This field is required.");
            $form.find("#submit-button").css("display", "none");
            $form.find("#clear-input").css("display", "inline-block");

            return false;
        }
        if (!validateEmail(inputEmail)) {
            showValidate("Email format is not valid.");
            $form.find("#submit-button").css("display", "none");
            $form.find("#clear-input").css("display", "inline-block");

            return false;
        }
        /* remove all alert */
        hideAlert($form);
        /* remove field error*/
        clearFieldError($form);
        /* collect input data then disable inputs */
        const postData = $form.serialize();

        /* ajax post process */
        $.ajax({
            url: siteUrl + "/api/newsletter-content",
            type: "GET",
            data: {
                email: inputEmail,
            },
            success: function (data) {
                showValidate(
                    "Email already registered. Please use different email address."
                );
            },
            error: function (data) {
                $.ajax({
                    url: $form.attr("action"),
                    type: "POST",
                    data: postData,
                    success: function (data) {
                        /* disabled input on submit */
                        showSuccess($form);
                        $("#input-email-mobile").hide();
                        $("#submit-button-mobile").hide();
                    },
                    error: function (data) {
                        showError($form, data.responseJSON.error);
                    },
                });
            },
        });

        function clearFieldError($form) {
            $form.find("input, textarea, select").removeClass("is-invalid");
        }

        function hideAlert($form) {
            $form.find(".invalid-feedback").text("");
        }

        function showValidate(message) {
            $form.find(".invalid-feedback").text("");
            $form.find(".invalid-feedback").text(message);
            $form.find(".input-group").addClass("has-error");
            $form.find("#submit-button-mobile").css("display", "none");
            $form.find("#clear-input-mobile").css("display", "inline-block");
        }

        function showSuccess($form, message = "") {
            $form.find(".valid-icon").removeClass("d-none");
            $form
                .find(".valid-feedback")
                .text("You have been successfully subscribed.");
            $form.find(".input-group").addClass("has-success");
        }

        function showError($form, errors) {
            $form.find(".invalid-feedback").text("");
            $form.find(".input-group").addClass("has-error");
            $form.find("#submit-button-mobile").css("display", "none");
            $form.find("#clear-input-mobile").css("display", "inline-block");

            try {
                for (const [key, value] of Object.entries(errors)) {
                    $form.find(".invalid-feedback").append(`${value}<br/>`);
                    $form.find(`[name=${key}]`).addClass("is-invalid");
                    $form.find(`[name=${key}] + .invalid-feedback`).text(value);
                }
            } catch (e) {
                $form
                    .find(".invalid-feedback")
                    .text("Oops, something went wrong");
            }
        }
    });
    $("#clear-input-mobile").on("click", function () {
        $(".invalid-feedback").text("");
        $(".invalid-feedback").css("display", "none");
        $(".input-group").removeClass("has-error");
        $("#input-email-mobile").val("");
        $("#submit-button-mobile").css("display", "inline-block");
        $("#clear-input-mobile").css("display", "none");
    });
});
